export default function ({state, commit, dispatch}, value) {
    let cb = () => {
    };
    if (value) {
        if (value.cb) cb = value.cb;
    }
    commit('cb', cb);

    if (state.loading || state.filter) {
        commit('cb');
        return;
    }
    commit('loading', true);
    axios({
        method: 'post',
        url: '/tourclient/legend/getLegend',
        data: 'request=' + JSON.stringify({ScreenName: state.data.ScreenName}),
    }).then(({data}) => {
        let error = '';
        if (!data) {
            error = 'Не удалось загрузить настройки: Сертификатов';
        } else if (data.ResultQueryInfo && data.ResultQueryInfo.UserMessages) {
            error = data.ResultQueryInfo.UserMessages;
        }
        if (error) {
            window.app.$notify.error({
                title: 'Ошибка',
                message: error,
            });
        }
        commit('data', data);

    }).catch(e => {
        if (!e) return;
        commit('data');
        dispatch('error', e, {root: true});
    });
}
